import React from "react";

import "../css/general.css";
import "../css/logo-btn.css";
import "../css/my-name.css";
import "../css/nav.css";
import "../css/style.css";
import "../css/queries.css";

export default function SectionHero() {
  return (
    <>
      <section className="section-hero">
        <div className="hero">
          <div className="hero-half">
            <h1 className="hero-heading">
              <span id="hello">Hello.</span>
            </h1>
            <h1 className="hero-heading">I am</h1>
            <h1 className="hero-heading">
              <span className="my-name">Jayant Arora</span>
            </h1>
            <p className="hero-description">
              <span className="hero-desc-one">&lt; Front-End &gt;</span>
              <span className="hero-desc-two">&lt; Web Design &gt;</span>
            </p>
          </div>
        </div>
        <div className="border bottom-side brdr--margin-top-hero"></div>
      </section>
    </>
  );
}
